import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetPaymentTradesService } from "@/features/accounts/payment/scraping/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetPaymentTradesResponseModel } from "@/features/accounts/payment/scraping/services/get-trades-model";


export const useGetPaymentTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getPaymentTradesService = new GetPaymentTradesService();

  // Look明細一覧取得
  const getPaymentTrades = async (
    accountGroupId: string,
    paymentAccountId: string,
    paymentId: string,
    startDate?: string,
    endDate?: string,
    offsetDate?: string,
  ) :Promise<GetPaymentTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getPaymentTradesService.getPaymentTrades({
        account_group_id:  accountGroupId,
        payment_account_id: paymentAccountId,
        payment_id: paymentId,
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
        ...(offsetDate && { offset_date: offsetDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getPaymentTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getPaymentTrades: errorHandledAsync(getPaymentTrades, setError),
  };
};
